module.exports = __webpack_public_path__ + "static/media/1.e46a4e1a.png";